import axios from 'axios';
import * as apiConstant from './apiConstant';

/****************************************
    activity management API
    @author  UYM
    @date    2020.5.16
    @version 0.1    
 ******************************************/
 class activityApi {
    static getPaginatedActivities(page) {
        var lang_key = localStorage.getItem('language');
        var url = `${apiConstant.API_URL}/blog/paginate/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}?business=activity&page=${page}&perpage=6`;
               
        return axios({
            url : url,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) {              
            return response;
        })
        .catch(function (error) {
            console.log("Get Blogs error==", error);
            return error;
        });
    }

    static getSideBlogs(targetId) {
        var lang_key = localStorage.getItem('language');
        var url = `${apiConstant.API_URL}/blog/others/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}?business=activity&tb=activity&t=${targetId}`;        
        return axios({
            url : url,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) { 
            return response;
        })
        .catch(function (error) {
            console.log("Get Blogs error==", error);
            return error;
        });
    }

    static getAll(delta) {
        var lang_key = localStorage.getItem('language');
        
        return axios({
          url : `${apiConstant.API_URL}/blog/all/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}/?business=activity&index=${delta}`,
          method: 'GET',
          headers: {
            'accept': 'application/json'
          }                  
        })     
        .then(function (response) {
            return response;              
        })
        .catch(function (error) {
          throw error;
        });    
    }

    static getFind(id) {
        var lang_key = localStorage.getItem('language');
        
        return axios({
          url : `${apiConstant.API_URL}/activity/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}/${id}`,
          method: 'GET',
          headers: {
            'accept': 'application/json'
          }                  
        })     
        .then(function (response) {
            return response;              
        })
        .catch(function (error) {
          throw error;
        });    
    }

    static getTitleByLang(business, id) {
        var lang_key = localStorage.getItem('language');
        return axios({
            url : `${apiConstant.API_URL}/${business}/title/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}/${id}`,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) {              
            return response;
        })
        .catch(function (error) {
            return error;
        });
    }
    
}

export default activityApi;